import { CONFIRM_DELETE_TEXT } from '@/pages/profile/blocks/children/sidebar/const';
import { observable } from './utils';
import { InitialState } from './types';
import { PopupData } from '../modules';

class ProfileStore<T extends InitialState> {
  private _state: T;

  constructor(private init: T) {
    this.init = init;
    this._state = observable<T>(this.init);
  }

  // Getters and setters

  get state(): T {
    return this._state;
  }

  set id(payload: string) {
    this._state.id = typeof payload === 'string' ? payload : '';
  }

  set fio(payload: string) {
    this._state.fio = typeof payload === 'string' ? payload : '';
  }

  set selector(payload: number) {
    this._state.selector = typeof payload === 'number' ? payload : 0;
  }

  set modal(payload: boolean) {
    this._state.modal = typeof payload === 'boolean' ? payload : false;
  }

  get isModalWindow() {
    return this._state.popup.isModalWindow;
  }

  get modalText() {
    return this._state.popup.modalText;
  }

  set modalText(payload: string) {
    this._state.popup.modalText = typeof payload === 'string' ? payload : '';
  }

  get modalHeader() {
    return this._state.popup.modalHeader;
  }

  set modalHeader(payload: string) {
    this._state.popup.modalHeader = typeof payload === 'string' ? payload : '';
  }

  get acceptButtonText() {
    return this._state.popup.acceptButtonText;
  }

  set acceptButtonText(payload: string) {
    this._state.popup.acceptButtonText =
      typeof payload === 'string' ? payload : '';
  }

  get declineButtonText() {
    return this._state.popup.declineButtonText;
  }

  set declineButtonText(payload: string) {
    this._state.popup.declineButtonText =
      typeof payload === 'string' ? payload : '';
  }

  get method() {
    return this._state.popup.method;
  }

  set method(payload: string) {
    this._state.popup.method = typeof payload === 'string' ? payload : '';
  }

  get confirmed() {
    return this._state.popup.confirmed;
  }

  set confirmed(payload: boolean) {
    this._state.popup.confirmed =
      typeof payload === 'boolean' ? payload : false;
  }

  get isDefaultButtons() {
    return this._state.popup.isDefaultButtons;
  }

  set isDefaultButtons(payload: boolean) {
    this._state.popup.isDefaultButtons =
      typeof payload === 'boolean' ? payload : true;
  }

  get isSidebarButtons() {
    return this._state.popup.isSidebarButtons;
  }

  set isSidebarButtons(payload: boolean) {
    this._state.popup.isSidebarButtons =
      typeof payload === 'boolean' ? payload : true;
  }

  get isNoButtons() {
    return this._state.popup.isNoButtons;
  }

  set isNoButtons(payload: boolean) {
    this._state.popup.isNoButtons =
      typeof payload === 'boolean' ? payload : false;
  }

  // mentoring popup
  get ismMentoringPopupOpen() {
    return this._state.mentoringPopup.isWindowOpen;
  }

  set ismMentoringPopupOpen(payload: boolean) {
    this._state.mentoringPopup.isWindowOpen =
      typeof payload === 'boolean' ? payload : false;
  }

  get mentoringPopupFormData() {
    return this._state.mentoringPopup.popupFormData;
  }

  openMentoringPopup(data: PopupData) {
    this._state.mentoringPopup.isWindowOpen = true;
    this._state.mentoringPopup.popupFormData = {
      ...data,
      kid_id: this._state.id,
    };
  }

  // Functions

  openModal() {
    this._state.popup.isModalWindow = true;
  }

  hideModal() {
    this._state.popup.isModalWindow = false;
  }

  closeModal() {
    this._state.popup.isModalWindow = false;
    this._state.popup.isSidebarButtons = false;
    this._state.popup.isDefaultButtons = true;
    this._state.popup.isNoButtons = false;
    this._state.popup.acceptButtonText = 'Да';
    this._state.popup.declineButtonText = 'Нет';
    this._state.popup.modalText = '';
    this._state.popup.modalHeader = '';
    this._state.popup.confirmed = false;
    this._state.popup.method = '';
  }

  reset() {
    this._state.id = '';
    this._state.selector = 0;
    this._state.modal = false;
  }
}

export default ProfileStore;



// WEBPACK FOOTER //
// ./src/pages/profile/store/store.ts